export interface IdentityApiError {
  code: IdentityApiErrorCode;
}

export enum IdentityApiErrorCode {
  InvalidModel,
  LoginExists,
  EmailExists,
  SendEmailError,
  UserNotFound,
  Unknown
}

export function GetIdentityApiErrorCodeName(
  code: IdentityApiErrorCode
): string {
  switch (code) {
    case IdentityApiErrorCode.InvalidModel:
      return 'Неверные данные';
    case IdentityApiErrorCode.LoginExists:
      return 'Указанный логин уже существует';
    case IdentityApiErrorCode.EmailExists:
      return 'Указанный e-mail уже существует';
    case IdentityApiErrorCode.SendEmailError:
      return 'Ошибка отправки email';
    case IdentityApiErrorCode.UserNotFound:
      return 'Пользователь не найден';
    case IdentityApiErrorCode.Unknown:
      return 'Неизвестная ошибка';
  }
}
